/*
  OTB: puente Prestige -> STOQ (Restock Rocket).
  Prestige cambia de variante sin recargar la pagina: avisa con 'variant:change'
  y despues vuelve a pintar el bloque de botones de compra, lo que borra el boton
  "AVISAME CUANDO REGRESEN" de STOQ. Resultado: el boton solo aparecia si la
  pagina se abria ya con una talla agotada.
  1) En cada cambio de variante le decimos a STOQ cual es la nueva.
  2) Si Prestige repinta y la variante elegida esta agotada pero el boton ya no
     existe, le pedimos a STOQ que lo vuelva a poner.
*/
(function () {
  function stoq() { return window._Stoq || window._RestockRocket; }
  function config() { return window._StoqConfig || window._RestockRocketConfig; }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    var s = stoq();
    if (variant && s && typeof s.renderButtonForVariant === 'function') {
      s.renderButtonForVariant(variant.id);
    }
  });

  function ensureButton() {
    var s = stoq(), c = config();
    if (!s || !c || typeof s.renderButtonForVariant !== 'function') return;
    if (c.selected_variant_available !== false) return;
    if (document.querySelector('.restock-rocket-button-container')) return;
    s.renderButtonForVariant(c.selected_variant_id);
  }

  var timer;
  function start() {
    var main = document.getElementById('main') || document.body;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(ensureButton, 150);
    }).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
